import React, { useEffect, useState } from 'react';
import { useAsync } from 'react-use';
import cn from 'classnames';
import { IBaseSection, IContent } from 'src/interface';
import ContentService from 'src/services/ContentService';
import { ALIGN_TYPE, LIST_TYPE } from 'src/components';
import ContentSection from './ContentSection';

interface IProps extends IBaseSection<IContent> {
    className?: string;
    type?: LIST_TYPE;
    hasLayoutPhoto?: boolean;
    displayTimeIn?: number;
    alignList?: ALIGN_TYPE;
    alignItem?: ALIGN_TYPE;
    ComponentList?: React.FunctionComponent<any>;
    ComponentListProps?: any;
    isMobile?: boolean;
    customTopic?: string;
}

export default React.memo(function ContentWithFetchSection(props: IProps) {
    const { options = {}, customTopic } = props;
    let params = options?.more?.params || {};

    const state = useAsync(() =>
        ContentService.getList(options?.more?.url, params)
    );
    const [items, setItems] = useState<IContent[]>([]);

    useEffect(() => {
        if (state.value?.data?.items?.length) {
            const itemsFromState: IContent[] = state.value?.data.items || [];
            const idsDupFromState: { [key: number]: number } =
                state.value?.data.contentIdsDuplicate || {};
            const _window: any = window;
            let contents: IContent[] = [];
            if (
                _window &&
                _window._BM &&
                itemsFromState.length &&
                options.removeDuplicate
            ) {
                const contentIdsExclude: number[] =
                    _window._BM.contentIdsExclude || [];

                const contentIdsDuplicate: { [key: number]: number } =
                    _window._BM.contentIdsDuplicate || {};

                // get duplicate content in custom list
                const valIdsDupFromState = Object.keys(idsDupFromState)?.map(
                    (key: any) => +idsDupFromState[key]
                );

                // get mảng các key mà value đã tồn tại
                const filterIdsDupFromState = Object.keys(idsDupFromState)
                    ?.filter((key: any, index) => {
                        return (
                            valIdsDupFromState.indexOf(idsDupFromState[key]) !==
                            index
                        );
                    })
                    ?.map((item) => +item);

                // get array value từ map duplicate home
                const _contentIdsDuplicate = Object.keys(
                    contentIdsDuplicate
                )?.map((key: any) => contentIdsDuplicate[key]);

                // get mảng các key mà value không trùng với map ở home
                const _contentIdsDupFromState = Object.keys(
                    idsDupFromState
                )?.map((key: any) => {
                    if (
                        _contentIdsDuplicate.indexOf(idsDupFromState[key]) > 0
                    ) {
                        return +key;
                    }
                    return 0;
                });

                const _items = itemsFromState
                    .filter(
                        (item) => !contentIdsExclude.includes(item.contentId) // filter với content home
                    )
                    .filter(
                        (item) =>
                            !_contentIdsDupFromState.includes(item.contentId) // filter với map dedup home
                    )
                    .filter(
                        (item) =>
                            !filterIdsDupFromState.includes(item.contentId) // filter với mảng id đã dedup trong custom list
                    );

                if (_items.length) {
                    contents = _items.slice(
                        0,
                        state.value?.data.itemSizeLimit || _items.length
                    );
                }
            } else {
                contents = state.value?.data.items || [];
            }
            contents.forEach((content) => {
                if (customTopic) {
                    content.customTopic = customTopic;
                }
            });
            setItems(contents);
        }
    }, [state]);
    if (state.loading || !items.length) {
        return <></>;
    }

    return (
        <ContentSection
            {...props}
            classTitle={cn(
                'relative',
                'w-full mb-[12px]',
                'h-[2.6rem]',
                'text-[2.2rem] leading-[30px] text-[var(--primary)]',
                '[&>a]:block',
                '[&_span]:relative [&_span]:inline-block [&_span]:bg-white [&_span]:z-[1] [&_span]:pr-[15px]',
                'before:h-[2px] before:w-full before:absolute before:bg-[var(--primary)] before:bottom-[4px]'
            )}
            items={items}
        />
    );
});
